module.exports = __webpack_public_path__ + "img/user_blank.155a1b46.jpg";